import { ButtonPosition } from '@/common/manager/position/button-position';
import { CnButton } from '@cainiaofe/cn-ui';
import { executeFunction, getRealizeValue } from '@/common/util/util';
export const config = {
    value: 'textRender',
    position: [
        ButtonPosition.tableToolArea,
        ButtonPosition.tableBatchArea,
        ButtonPosition.formDialog,
        ButtonPosition.dialog,
        ButtonPosition.form,
        ButtonPosition.step,
        ButtonPosition.pageRightButton,
        ButtonPosition.blockButton,
    ],
    getRenderDom: (config) => {
        if (config) {
            const { buttonConfig, state, position, selectedRowKeys, selectedRowRecords, recordDataSource, } = config;
            const { options, children } = buttonConfig || {};
            const { content, color } = options || {};
            let realContent = children;
            if (typeof content === 'string' && content.length > 0) {
                realContent = content;
            }
            else if (typeof content === 'function') {
                if ([
                    ButtonPosition.tableBatchArea,
                    ButtonPosition.tableToolArea,
                ].includes(position)) {
                    realContent = executeFunction(content, recordDataSource, state, selectedRowKeys, selectedRowRecords);
                }
                else {
                    const formValue = getRealizeValue(recordDataSource);
                    realContent = executeFunction(content, formValue || {}, state);
                }
            }
            const style = {
                display: 'inline-block',
            };
            if (color) {
                style.color = color;
            }
            return (<CnButton style={style} text>
          {realContent}
        </CnButton>);
        }
    },
};
